/** @format */
import angular from 'angular';
import _ from 'lodash';
import { TooltipComponent } from '../tooltip/tooltip.component';
import displaySelectedParametersStaticTpl from './displaySelectedParametersStatic.tpl.html';
import { searchComponentUtilsServiceModule } from './searchComponentUtils.service';
import { searchParameterModelsModule } from './searchParameterModels';

export const displaySelectedParametersStaticModule = 'sis-components.search.displaySelectedParametersStatic';

(function () {
    displaySelectedParametersStaticController.$inject = ['SearchParameter', 'OrParameter', 'searchComponentUtilsService'];
    angular
        .module(displaySelectedParametersStaticModule, [
            searchComponentUtilsServiceModule,
            searchParameterModelsModule,
            TooltipComponent.downgrade.moduleName,
        ])
        .component('displaySelectedParametersStatic', {
            template: displaySelectedParametersStaticTpl,
            controller: displaySelectedParametersStaticController,
            bindings: {
                searchParams: '<',
                searchParameterOptions: '<',
                plainDisplayMode: '@',
            },
        });

    function displaySelectedParametersStaticController(SearchParameter, OrParameter, searchComponentUtilsService) {
        const $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.searchParamKeys = _.keys($ctrl.searchParams);
            $ctrl.isPlainDisplayMode = $ctrl.plainDisplayMode === 'true';
        };

        $ctrl.searchParameterIsValid = function (searchParameterKey) {
            if ($ctrl.searchParams[searchParameterKey] instanceof SearchParameter) {
                return $ctrl.searchParams[searchParameterKey].isValidForSearch();
            }
        };

        $ctrl.getFullParameterValue = function (searchParameterKey) {
            if ($ctrl.searchParams[searchParameterKey] instanceof SearchParameter) {
                const displayValue = $ctrl.searchParams[searchParameterKey].displayValue();

                if (!(displayValue instanceof Array)) {
                    // There might be string and object values (e.g. CreditRange) so we need to wrap those
                    return [displayValue];
                }
                return displayValue;
            }
        };

        $ctrl.getParameterValue = searchParameterKey =>
            searchComponentUtilsService.getDisplayValueString($ctrl.searchParams[searchParameterKey]);

        $ctrl.showSearchParameterTooltip = function (searchParameterKey) {
            if ($ctrl.searchParams[searchParameterKey] instanceof SearchParameter) {
                const displayValue = $ctrl.searchParams[searchParameterKey].displayValue();
                let displayArray;
                let charLength = 0;
                let wordCount = 0;
                const maximumAllowedDisplayLength = 30;

                if (!(displayValue instanceof Array)) {
                    // There might be string and object values (e.g. CreditRange) so we need to wrap those
                    displayArray = [displayValue];
                } else {
                    displayArray = displayValue;
                }

                _.forEach(displayArray, value => {
                    charLength += value.length;
                    if (charLength < maximumAllowedDisplayLength) {
                        wordCount++;
                    }
                });

                return wordCount === 0 || wordCount < displayArray.length;
            }
        };
    }
})();
